var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNameIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 25,
    viewBox: "0 0 20 25",
    fill: "#1A1A1A",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99766 15.625C11.9445 15.625 13.5227 14.1454 13.5227 12.3203C13.5227 10.4952 11.9445 9.01562 9.99766 9.01562C8.05085 9.01562 6.47266 10.4952 6.47266 12.3203C6.47266 14.1454 8.05085 15.625 9.99766 15.625Z",
    fill: "#1A1A1A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 1.5625C12.5 1.1481 12.3244 0.750671 12.0118 0.457646C11.6993 0.16462 11.2754 0 10.8333 0H9.16667C8.72464 0 8.30072 0.16462 7.98816 0.457646C7.6756 0.750671 7.5 1.1481 7.5 1.5625V6.25H12.5V1.5625Z",
    fill: "#1A1A1A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.55068 19.5309C3.40901 19.6911 3.33228 19.8931 3.33401 20.1012V21.8746H16.6673V20.0777C16.6698 19.8695 16.593 19.6673 16.4507 19.5074C15.642 18.6628 14.6449 17.9954 13.5302 17.5525C12.4155 17.1096 11.2105 16.9022 10.0007 16.9449C8.78893 16.9051 7.58273 17.1162 6.4679 17.5632C5.35307 18.0101 4.35704 18.682 3.55068 19.5309Z",
    fill: "#1A1A1A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3333 3.125H14.1667V4.6875H18.3333V23.4375H1.66667V4.6875H5.83333V3.125H1.66667C1.22464 3.125 0.800716 3.28962 0.488155 3.58265C0.175595 3.87567 0 4.2731 0 4.6875V23.4375C0 23.8519 0.175595 24.2493 0.488155 24.5424C0.800716 24.8354 1.22464 25 1.66667 25H18.3333C18.7754 25 19.1993 24.8354 19.5118 24.5424C19.8244 24.2493 20 23.8519 20 23.4375V4.6875C20 4.2731 19.8244 3.87567 19.5118 3.58265C19.1993 3.28962 18.7754 3.125 18.3333 3.125Z",
    fill: "#1A1A1A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNameIcon);
export default __webpack_public_path__ + "static/media/NameIcon.bddb6e3c783ce0981b1fcb936b5f91ae.svg";
export { ForwardRef as ReactComponent };